import React from "react";
import { Select, Form, Input, Button, Icon } from "antd";
import Axios from "axios";
import { Typography } from "antd";
import { breakOnDifferentCase } from "./../util/StringUtil";
import { TableApi } from "../controllers/TableSchema";
import "./TableFilter.css";
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { format } from "date-fns";
import 'antd/dist/antd.css';


export type TableFilterDropDownProps = {
  id: string
};

type FilterFormProps = {
  id: string,
  form?: any,
  onSubmit: (selectedValues: any) => void
};

type State = {
  prevId: string,
  data: ?Object,
  formItems: Array<any>,
  selectValues: Map<string, Set<string>>,
  date: Object<any>,
  openDateModal: Boolean
};

class FilterForm extends React.PureComponent<FilterFormProps, State> {
  formItems: Array<Object>;

  constructor(props: FilterFormProps) {
    super(props);
    this.formItems = [];
    this.dateModalRef = React.createRef(null)
    this.state = {
      data: null,
      formItems: [],
      selectValues: new Map(), prevId: "",
      date: {
        selection: {
          startDate: new Date(),
          endDate: null,
          key: 'selection'
        }
      },
      openDateModal: false
    };
  }

  static getDerivedStateFromProps(props: FilterFormProps, state: State) {
    // Store prevId in state so we can compare when props change.
    // Clear out previously-loaded data (so we don't render stale stuff).
    if (props.id !== state.prevId) {
      return {
        data: null,
        prevId: props.id
      };
    }
    // No state update necessary
    return null;
  }

  componentDidUpdate(prevProps: FilterFormProps, prevState: State) {
    if (!this.state.data) {
      this.componentDidMount();
    }
    if (prevProps.id !== this.props.id) {
      this.handleClearDateInput()
    }
  }

  componentDidMount() {
    const axios = Axios.get(TableApi.GET_TABLE_FILTERS + "/" + this.props.id);
    axios
      .then(response => {
        this.setState({ data: response.data });
      })
      .catch(error => {
        console.error(error);
        alert(error);
      });
    document.addEventListener("click", this.hideDateModalonBlur, true);
  };

  hideDateModalonBlur = (event) => {
    if (this.dateModalRef.current && !this.dateModalRef.current.contains(event.target)) {
      this.setState({ openDateModal: false });
    }
  }


  process(filterName: string, filterData: Object, formItems: Array<Object>) {
    const filterKeys: Array<string> = Object.keys(filterData);
    filterKeys.sort();
    const options = [];
    if (filterName === 'submitDuration') {
      formItems.push(this.createDateFilter(filterName, filterName))
    }
    else {
      for (let index = 0; index < filterKeys.length; index++) {
        const filterKey: string = filterKeys[index];
        const label: string = filterData[filterKey];
        const option = this.createOption({ key: filterKey, label: label });
        options.push(option);
      }
      if (options.length === 0) {
        //Options is empty, that means user wants to create text box.
        formItems.push(this.createTextInput(filterName, filterName));
      }
      else {
        formItems.push(this.createSelect(filterName, filterName, options));
      }
    }
    return formItems;
  }

  handleSubmit = e => {
    e.preventDefault();
    if (this.props.form) {
      this.props.pagination.current = 1;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          this.props.onSubmit(values);
        } else {
          alert(err);
        }
      });
    }
  };

  onDropDownSelectUnSelect(key: string, select: boolean, value: string) {
    const map = new Map(this.state.selectValues);
    let values: ?Set<string> = map.get(key);
    if (!values) {
      values = new Set();
      map.set(key, values);
    }
    if (values) {
      if (select) values.add(value);
      else values.delete(value);
    }
    this.setState({ selectValues: map });
  }

  createSelect(key: string, label: string, children: Array<any>) {
    if (this.props.form) {
      const getFieldDecorator = this.props.form.getFieldDecorator;
      return (
        <Form.Item label={label.toUpperCase()} name={key} key={key}>
          {getFieldDecorator(key, {})(
            <Select
              name={key}
              mode="multiple"
              style={{ minWidth: "200px", maxWidth: "100%" }}
              allowClear={true}
              onSelect={v => this.onDropDownSelectUnSelect(key, true, v)}
              onDeselect={v => this.onDropDownSelectUnSelect(key, false, v)}
            >
              {children}
            </Select>
          )}
        </Form.Item>
      );
    }
  }

  createTextInput(key: string, label: string) {
    if (this.props.form) {
      const getFieldDecorator = this.props.form.getFieldDecorator;
      return (
        <Form.Item label={label.toUpperCase()} key={key}>
          {getFieldDecorator(key, {})(<Input placeholder={label} name={key} />)}
        </Form.Item>
      );
    }
  }

  createOption(props: { key: string, label: string }) {
    return (
      <Select.Option key={props.key} value={props.key}>
        {props.label}
      </Select.Option>
    );
  }

  setDateFilterValue() {
    const startDate = this.state.date.selection.startDate;
    const endDate = this.state.date.selection.endDate;
    const selectedDate = startDate && endDate ? `${format(startDate, "yyyy-dd-MM")} to ${format(endDate, "yyyy-dd-MM")}` : '';
    return selectedDate;
  }

  handleClearDateInput = () => {
    this.setState(prevState => ({
      date:
      {
        ...prevState.date,
        selection: {
          ...prevState.date.selection,
          endDate: null
        }
      }
    }))
  }


  handleSubmitDurationFocus = () => {
    this.setState({ openDateModal: true });
  }

  createDateFilter(key: string, label: string) {
    const getFieldDecorator = this.props.form.getFieldDecorator;
    return (
      <div className="headerSearchItem" key={key}>
        <Form.Item label={label.toUpperCase()} key={key}>
          <div style={{ width: '14rem' }}>
            {getFieldDecorator(key, { initialValue: this.setDateFilterValue() })(
              <Input
                onClick={this.handleSubmitDurationFocus}
                placeholder={label}
                name={key}
                autoComplete = "off"
                readOnly
                addonAfter={this.state.date.selection.endDate && (
                  <Icon type="close-circle" onClick={this.handleClearDateInput} style={{ cursor: 'pointer', color: 'darkorange' }} />
                )}
              />
            )}
          </div>
        </Form.Item>
        <div ref={this.dateModalRef} >
          {this.state.openDateModal && <DateRangePicker
            className="dateFilter"
            onChange={(item) => {
              this.setState({ date: { ...this.state.date, ...item } })
            }}
            maxDate={new Date()}
            direction="vertical"
            ranges={[this.state.date.selection]}
            showDateDisplay={false}
          />}
        </div>
      </div>
    );
  }

  clearFilters = () => {
     this.props.form.resetFields();
     this.handleClearDateInput();
  }


  render() {
    let formItems = [];
    if (this.state.data) {
      const data = this.state.data;
      if (data && data.entries) {
        const entries: Object = data.entries;
        const keys: Array<string> = Object.keys(entries);
        keys.sort();
        for (let index = 0; index < keys.length; index++) {
          const filterName: string = keys[index];
          formItems = this.process(filterName, entries[filterName], formItems);
        }
      }
    }
    return (
      <div>
        <Typography.Title level={4} type="secondary" >
          Filters
        </Typography.Title>
        <Form onSubmit={this.handleSubmit} layout="inline">
          {formItems}
          <Form.Item>
            <Button type="primary" htmlType="submit" >
              Submit
            </Button>
            <Button onClick={this.clearFilters} htmlType="submit">
              Reset
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default Form.create({ name: "filter-form" })(FilterForm);
